// extracted by css-extract-rspack-plugin
export default {"legend":"nmzhkAHb55IM9amx"};